// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.summary.LeaseSummaryOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetLeaseSummaryFromOuidResponseDto } from '../..';

interface GetLeaseSummaryFromOuidParams {
  ouid: string;
}

export const LeaseSummaryOuidWebApiHandler_getLeaseSummaryFromOuid_Path = '/api/web/v1/ouid/getLeaseSummaryFromOuid';

/**
 * get lease summary from ouid
 */
export const LeaseSummaryOuidWebApiHandler_getLeaseSummaryFromOuid = (
  getParams: GetLeaseSummaryFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeaseSummaryFromOuidParams, never, GetLeaseSummaryFromOuidResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseSummaryOuidWebApiHandler_getLeaseSummaryFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
